<template>
  <div
    class="aha-input-__wrapper w-full relative"
    ref="inputSeachContainer"
  >
    <input
      :type="type"
      :placeholder="placeholder"
      :class="[
        `aha-input-${size}`,
        {
          'rounded': rounded,
          'aha-input-limit': maxLength,
          'hover:border-primary-90 focus:border-primary-90': highlightOnHover,
          error,
        },
        classes
      ]"
      :required="required"
      :autofocus="autofocus"
      :value="value"
      @input="handleInput"
      @keyup="handleKeyup"
      v-on="listeners"
      class="aha-input"
      :maxlength="maxLength"
      ref="inputSearch"
      @focus="handleInputFocus"
      @blur="handleInputBlur"
      :disabled="disabled"
    >

    <aha-icon
      name="search"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      class="text-base-50 absolute right-2 top-2.5"
    />
  </div>
</template>

<script>
import AhaIcon from './Icon.vue'

export default {
  components: {
    AhaIcon,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      default: '',
      type: [String, Number],
    },
    type: {
      default: 'text',
      type: String,
    },
    placeholder: {
      default: '',
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    autofocus: {
      default: false,
      type: Boolean,
    },
    size: {
      default: 'md',
      type: String,
    },
    maxLength: {
      default: null,
      type: Number,
    },
    classes: {
      type: String,
      default: '',
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    error: {
      type: Boolean,
      default: false,
    },
    focus: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    highlightOnHover: {
      type: Boolean,
      default: true,
    },
    maxWidth: {
      type: String,
      default: '100px',
    },
  },
  data() {
    return {
      isCharacterCounterShowing: false,
    }
  },
  computed: {
    listeners() {
      const { input, keyup, ...listeners } = this.$listeners
      return listeners
    },
    characterCounter() {
      if (this.value && this.value.length > this.maxLength) {
        return 0
      }
      return this.value ? this.maxLength - this.value.length : this.maxLength
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.focus) {
        this.$refs.inputSearch.focus()
      }
    })
  },
  methods: {
    focusInput() {
      this.$refs.input.focus()
    },
    handleInputFocus() {
      this.isCharacterCounterShowing = true
    },
    handleInputBlur() {
      this.isCharacterCounterShowing = false
    },
    handleInput($event) {
      this.$emit('input', $event.target.value)
    },

    handleKeyup($event) {
      this.$emit('keyup', $event)
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-input__wrapper {
  @apply relative;
}

.aha-input__ghost-input {
  @apply invisible absolute whitespace-nowrap;
  font-size: inherit;
  font-weight: inherit;
}

.aha-input {
  @apply appearance-none;
  @apply px-2 h-10 text-sm w-full border border-secondary-20;
  @apply focus:bg-primary-20 focus:outline-none;
  @apply hover:bg-primary-20;
  @apply placeholder-base-70;
  font-size: inherit;
  font-weight: inherit;
  &.error, &:hover.error {
    border: 1px solid #ff5050;
    border-color: #ff5050;
  }
}

.aha-input-limit {
  @apply pr-9;
}

.aha-input--char-counter {
  @apply absolute h-10 top-0 flex items-center right-2 text-secondary-40 text-sm font-normal;
}

.aha-input-group>.aha-input__wrapper>.aha-input {
  @apply rounded-l-none;
}

.aha-input-group:hover>.aha-input__wrapper>.aha-input {
  @apply border-primary-90 bg-primary-20;
}

.aha-input.aha-input-sm {
  @apply h-8 text-xs;
  + .aha-input--char-counter {
    @apply h-8;
  }
}
.aha-input.aha-input-md {
}
.aha-input.aha-input-lg {
}
</style>
